import { configureStore } from '@reduxjs/toolkit';
import menuReducer from './menuSlice';
import usersReducer from './userTabSlice';
import tokensReducer from './tokensSlice';
import sportsReducer from './sportsTabSlice';
import notificationsReducer from './notificationsTabSlice';
import opinionsReducer from './opinionsTabSlice';
import opinionsTTabReducer from './opinionsTTabSlice';
import opinionsUTabReducer from './opinionsUTabSlice';
import trainingsReducer from './trainingsTabSlice';
import statsReducer from './statsTabSlice';
import faqReducer from './faqTabSlice';
import documentsReducer from './documentsTabSlice';
import encyclopediaReducer from './encyclopediaTabSlice';
import { loadTokensFromStorage } from './tokensPersistence';

const persistedTokens = loadTokensFromStorage();
const preloadedState = persistedTokens ? { tokens: persistedTokens } : undefined;

const store = configureStore({
  preloadedState,
  reducer: {
    menu: menuReducer,
    users: usersReducer,
    tokens: tokensReducer,
    sports: sportsReducer,
    notifications: notificationsReducer,
    opinions: opinionsReducer,
    opinionsT: opinionsTTabReducer,
    opinionsU: opinionsUTabReducer,
    trainings: trainingsReducer,
    stats: statsReducer,
    faq: faqReducer,
    documents: documentsReducer,
    encyclopedia: encyclopediaReducer,
    }});

export default store;